import { defineStyleConfig } from "@chakra-ui/react";
import { fonts } from "../fonts";
import { colours } from "../colours";

export const buttonTheme = defineStyleConfig({
	defaultProps: {
		variant: "solid",
	},
	baseStyle: {
		color: colours.text.title,
		bg: colours.neutrals[50],
		p: "20px",
		borderRadius: "md",
		_focus: {
			boxShadow: "outline",
		},
		fontFamily: fonts.buttons,
		fontWeight: 500,
	},
	variants: {
		solid: {
			bg: colours.brand[400],
			color: colours.text.white,
			_hover: {
				bg: colours.brand[500],
				_disabled: {
					bg: colours.brand[400],
				},
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.brand[500],
			},
		},
		subtle: {
			bg: colours.brand[200],
			color: colours.text.link.default,
			_hover: {
				bg: colours.brand[300],
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.brand[400],
			},
		},
		outline: {
			bg: "transparent",
			color: colours.text.link.default,
			borderColor: colours.brand[400],
			borderWidth: "1px",
			borderStyle: "solid",
			_hover: {
				bg: colours.brand[200],
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.brand[300],
			},
			_disabled: {
				borderColor: "transparent",
			},
		},
		danger: {
			bg: colours.accent.red[400],
			color: colours.text.white,
			_hover: {
				bg: colours.accent.red[600],
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.accent.red[600],
			},
		},
	},
});
